import { FC } from 'react'

import styled from 'styled-components'

import DangerIcon from 'src/Assets/Svg/Danger.svg?react'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { PaymentErrors } from 'src/Components/PaymentErrorsAlert'

const Text = styled.div`
  font-size: 14px;
  line-height: 21px;
  text-align: left;
  color: ${({ theme }) => theme.color.mediumRed};
`

const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
`

export const PaymentError: FC = () => {
  const { search } = useCustomSearchParams()
  const error = search.get('error')
  const errorType = search.get('errorType')

  if (!error && !errorType) {
    return null
  }

  const errorText =
    errorType === PaymentErrors.CHANGE_METHOD
      ? 'Oops! There was an issue processing your payment. Please try a different payment method'
      : 'Oops! Something went wrong. Please try again later or use a different payment method.'

  return (
    <Container>
      <DangerIcon />
      <Text>{errorText}</Text>
    </Container>
  )
}
